import PanelBottomSvg from '@assets/images/svg/panel-bottom.svg';
import React from 'react';

export interface PanelBottomIconProps {
    size?: number;
    color?: string;
}

export const PanelBottomIcon = React.memo<PanelBottomIconProps>(function PanelBottomIcon({ size = 24, color = '#1A1A1A' }) {
    return <PanelBottomSvg width={size} height={size} color={color} />;
});

export default PanelBottomIcon;


